import { NavigateFunction } from "react-router-dom";

import { Workspace } from "@/types/workspaces";

export const redirectToDefaultWorkspace = (
  workspaces: Workspace[],
  excludeOrganizationId: number,
  navigate: NavigateFunction,
) => {
  const availableWorkspaces = workspaces.filter(
    workspace => workspace.organization_id !== excludeOrganizationId,
  );

  if (availableWorkspaces.length === 0) {
    navigate("/home");

    return;
  }

  const workspacesByOrg = availableWorkspaces.reduce(
    (acc, workspace) => {
      if (!acc[workspace.organization_id]) {
        acc[workspace.organization_id] = [];
      }
      acc[workspace.organization_id].push(workspace);
      return acc;
    },
    {} as Record<number, Workspace[]>,
  );

  const firstOrgId = Object.keys(workspacesByOrg)[0];
  const firstOrgWorkspaces = workspacesByOrg[Number(firstOrgId)];

  const defaultWorkspace = firstOrgWorkspaces.find(workspace => workspace.is_default);
  const targetWorkspace = defaultWorkspace || firstOrgWorkspaces[0];

  if (targetWorkspace) {
    navigate(`/workspace/${targetWorkspace.id}/home`);

    return;
  }

  navigate("/home");
};
